import React, { useEffect, lazy, Suspense } from 'react'
import { Outlet, useParams, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import { InnerPageData } from '../../../action/index'; // import the action
import ApiClient from '../../API/ApiClient'
const Footer = lazy(() => import('../../Footer/Footer'));

const MainTemplate = () => {
    const navigate = useNavigate();
    const { getRequestApi } = ApiClient();
    const dispatch = useDispatch();
    const { slug, language = 'en' } = useParams();

    const updateMetaTags = (title, description, keywords) => {
        // Update title
        document.title = title || 'Default Title';

        // Update or create meta description
        let metaDescription = document.querySelector('meta[name="description"]');
        if (!metaDescription) {
            metaDescription = document.createElement('meta');
            metaDescription.name = 'description';
            document.head.appendChild(metaDescription);
        }
        metaDescription.content = description || 'Default description';

        // Update or create meta keywords
        let metaKeywords = document.querySelector('meta[name="keywords"]');
        if (!metaKeywords) {
            metaKeywords = document.createElement('meta');
            metaKeywords.name = 'keywords';
            document.head.appendChild(metaKeywords);
        }
        metaKeywords.content = keywords || 'default,keywords';

        // Update Open Graph tags (for social sharing)
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) ogTitle.content = title;

        const ogDescription = document.querySelector('meta[property="og:description"]');
        if (ogDescription) ogDescription.content = description;
    };

    const loadPreLoadData = async () => {
        if (slug) {
            const response = await getRequestApi(`post/${slug}/${language}`);

            if (response?.status && response.data) {
                const postMeta = response.data.post_meta || {};

                // respose.data.post_meta.meta have the data 
                updateMetaTags(
                    postMeta.nfdc_meta_title || response.data.title,
                    postMeta.nfdc_meta_description,
                    postMeta.nfdc_meta_keywords,
                );

                dispatch(InnerPageData(response.data));
            } else {
                // alert("dd");
                //   navigate("404");
                window.location.href = '/404';

            }

        }

    }
    useEffect(() => {
        loadPreLoadData();
    }, [language, slug]);
    return (
        <>

            <Outlet />
            <Suspense fallback={<div>Loading Page...</div>}>
                <Footer />
            </Suspense >
        </>
    )
}

export default MainTemplate